import { formatLogTimestamp } from './logTimestamp.ts';

export function formatStructuredLogLine(logData: object): string {
  return `[${formatLogTimestamp()}] ${JSON.stringify(logData)}`;
}
